// Moving through a room's presenting order on the vote panel. Pure, so it's tested in client/test.

/**
 * The team before or after `current` in the presenting order that you can pick (never your own), or null at either end.
 * For the vote panel's previous / next buttons.
 */
export const stepTeam = (lineup: string[], current: string, direction: 1 | -1, isOwn: (id: string) => boolean) => {
    for (let i = lineup.indexOf(current) + direction; i >= 0 && i < lineup.length; i += direction) {
        if (!isOwn(lineup[i])) {
            return lineup[i];
        }
    }
    return null;
};

/**
 * The next team you still have to score: presented (or on stage), not yours, not yet scored. Looks after `current` first,
 * then from the top, so a team skipped earlier isn't missed. Null when there's none left.
 */
export const nextToScore = (lineup: string[], current: string, isDue: (id: string) => boolean, isScored: (id: string) => boolean, isOwn: (id: string) => boolean) => {
    const at = lineup.indexOf(current);
    const order = [...lineup.slice(at + 1), ...lineup.slice(0, at + 1)];
    return order.find(id => id !== current && isDue(id) && !isScored(id) && !isOwn(id)) ?? null;
};
